import { observer } from 'mobx-react-lite';
import React from 'react';

import type { Billable } from '@feathr/blackbox';
import type { IFormSubmitProps } from '@feathr/components';
import { Button, Form, FormSubmit, Input } from '@feathr/components';

interface IProps {
  billable: Billable;
  onNext: () => void;
  onPrevious?: () => void;
}

function BillableStepOne({ billable, onNext, onPrevious }: IProps) {
  const refs: IFormSubmitProps<Billable>['refs'] = {
    name: React.useRef<HTMLInputElement>(null),
    email: React.useRef<HTMLInputElement>(null),
  };

  return (
    <Form
      actions={[
        <FormSubmit<Billable> key={'next'} model={billable} onClick={onNext} refs={refs}>
          Next
        </FormSubmit>,
        onPrevious ? (
          <Button key={'previous'} onClick={onPrevious} type={'naked'}>
            Previous
          </Button>
        ) : undefined,
      ]}
      label={'Billing configuration settings: Contact information'}
    >
      <Input
        attribute={'name'}
        label={'Name'}
        model={billable}
        ref={refs.name}
        required={true}
        type={'text'}
      />
      <Input
        attribute={'email'}
        label={'Email'}
        model={billable}
        ref={refs.email}
        required={true}
        type={'email'}
      />
    </Form>
  );
}

export default observer(BillableStepOne);
